import React from 'react';
import styled from 'styled-components';

import { Card } from 'antd';

const StyledCard = styled(Card)`
  background-color: white;
  border-radius: 24px;
  margin: 12px 0;
  box-shadow: 4px 4px 6px 0 rgba(0, 0, 0, 0.09);
  width: 100%;

  .ant-card-head {
    border-bottom: none !important;
  }
`;

const CardWithIconHeader = ({ children, ...rest }) => {
  return <StyledCard {...rest}>{children}</StyledCard>;
};

export default CardWithIconHeader;
